export default __webpack_public_path__ + "static/media/twitterfWhite.afd5a96f.svg";